import React from "react";
import { COLORS } from "../constants";

interface OtpInputProps {
  otp: string[];
  otpRefs: React.RefObject<HTMLInputElement>[];
  onChange: (value: string, index: number) => void;
  onValidate: () => void;
  onResend: () => void;
}

export const OtpInput: React.FC<OtpInputProps> = ({
  otp,
  otpRefs,
  onChange,
  onValidate,
  onResend,
}) => {
  return (
    <div style={{ marginTop: "6px" }}>
      {/* OTP BOXES */}
      <div style={{ display: "flex", gap: "2px" }}>
        {otp.map((digit, i) => (
          <input
            key={i}
            ref={otpRefs[i]}
            maxLength={1}
            value={digit}
            onChange={(e) => onChange(e.target.value, i)}
            style={{
              width: "16px",
              height: "16px",
              textAlign: "center",
              fontSize: "0.75rem",
              borderRadius: "5px",
              border: `1px solid ${COLORS.brandTeal}`,
            }}
          />
        ))}
        {/* ACTION LINKS */}
        <div
          style={{
            display: "flex",
            gap: "4px",
            marginTop: "4px",
            fontSize: "0.5rem",
          }}
        >
          <span
            onClick={onValidate}
            style={{
              color: COLORS.brandTeal,
              fontWeight: 700,
              cursor: "pointer",
              textDecoration: "underline",
            }}
          >
            Validate
          </span>

          <span
            onClick={onResend}
            style={{
              color: COLORS.brandPurple,
              fontWeight: 600,
              cursor: "pointer",
              textDecoration: "underline",
            }}
          >
            Resend
          </span>
        </div>
        {/* OTP INFO */}
        <div
          style={{
            marginTop: "4px",
            fontSize: "0.5rem",
            color: "#666",
          }}
        >
          OTP valid for 3 min
        </div>
      </div>
    </div>
  );
};
